import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { Route, Redirect, Link, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Table,
  Form,
  Input,
  Switch,
  Select,
  Checkbox,
  Button,
  Modal,
  Cascader,
  message,
  Slider,
  InputNumber,
  Tag,
  Upload,
} from "antd";
import cookie from "react-cookies";
import "./list.less";
import {
  ExclamationCircleOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import moment from "moment";
import qs from "qs";
import {} from "../../api/user";
import { base } from "../../api/config";
import { useTranslation } from "react-i18next";
import { exportPDF } from "../../common/exportPDF";

const List = () => {
  const { t } = useTranslation();
  const { pathname, search } = useLocation();
  const [params, setParams] = useState(undefined);
  const [num, setNum] = useState(undefined);
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const param = qs.parse(search.split("?")[1]);
    setParams(param);
    // console.log(param);
    const arr = param.file.split(".png")[0].split("_");

    setNum(Math.round(arr[arr.length - 1] * 100) / 100);
    setLang(localStorage.getItem("i18nextLng"));
  }, []);

  const divRef = useRef(null);

  return (
    <div className="task detail px-5">
      <div className="actions d-flex justify-content-between mb-3">
        <Button size="large" href="/index/task/list">
          {t("pages.viewTask.btn1")}
        </Button>
        <Button
          onClick={() => {
            exportPDF(params?.pdf, divRef.current);
          }}
          size="large"
          type="primary"
        >
          {t("pages.viewTask.btn2")}
        </Button>
        {/* <Button
          href={`${base}/task/${params?.pdf}`}
          target="_blank"
          download={params?.pdf}
          size="large"
          type="primary"
        >
          {t("pages.viewTask.btn2")}
        </Button> */}
      </div>
      <div className="preview mb-3" ref={divRef}>
        <div className="title">
          {t("pages.viewTask.title")}
          {/* 预测结果 */}
        </div>
        <div className="subtitle text-center">
          {t("pages.viewTask.subtitle1")}
          <b>{num}</b>，{t("pages.viewTask.subtitle2")}
          <b>
            {(num < 0.5 && t("pages.viewTask.subtitleDanger1")) ||
              (num >= 0.5 &&
                num <= 0.75 &&
                t("pages.viewTask.subtitleDanger2")) ||
              (num > 0.75 && t("pages.viewTask.subtitleDanger3"))}
          </b>
          ，{(lang == "en" && <br />) || ""}
          {t("pages.viewTask.subtitle3")}
          <b>
            {(num < 0.5 && "3.1%") ||
              (num >= 0.5 && num <= 0.75 && "8.6%") ||
              (num > 0.75 && "21.0%")}
          </b>
          {(lang == "en" && ".") || "。"}
        </div>
        <div className="table-cont">
          <div className="subtitle text-center mb-3">
            {t("pages.viewTask.tableTitle")}
          </div>
          <table className="table">
            <thead>
              <tr>
                <th>{t("pages.viewTask.th1")}</th>
                <th>{t("pages.viewTask.th2")}</th>
                <th>{t("pages.viewTask.th3")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>＜0.5</td>
                <td>{t("pages.viewTask.danger1")}</td>
                <td>3.1% (95% {t("pages.viewTask.text1")}: 1.2%-5.1%)</td>
              </tr>
              <tr>
                <td>0.5-0.75</td>
                <td>{t("pages.viewTask.danger2")}</td>
                <td>8.6% (95% {t("pages.viewTask.text1")}: 5.8%-11.4%)</td>
              </tr>
              <tr>
                <td>＞0.75</td>
                <td>{t("pages.viewTask.danger3")}</td>
                <td>21.0% (95% {t("pages.viewTask.text1")}: 12.0%-29.1%)</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* <div className="line-img">
          <img src={require("../../assets/image/line-img.jpg").default} />
        </div> */}
        <div className="hot-img">
          <div className="title">
            {t("pages.viewTask.hottitle")}
            {/* 热力图 */}
          </div>
          <img
            src={`${base}/task/${params?.file}`}
            style={{ maxWidth: "100%", maxHeight: "800px" }}
          />
        </div>
        <div className="line-img mt-5">
          <img
            src={
              require(`../../assets/image/line${lang == "en" ? "-en" : ""}.png`)
                .default
            }
          />
        </div>
        <div className="tips">
          <p>
            {t("pages.viewTask.tip1")}
            {/* 注：结果仅供临床医生参考，不作为疾病诊断和证明的依据 */}
          </p>
          {/* <p>本报告仅供医生参考，不能作为疾病诊断和证明的依据</p> */}
        </div>
      </div>
    </div>
  );
};

export default List;
